module.exports = {
	///WSS通信域名
	WSS_SERVER_URL: '',
	// 后台版本号
	SYSTEM_VERSION: 1,

	HEADER: {
		'content-type': 'application/json',
    'Form-type':'PC'
	},
	// 回话密钥名称 请勿修改此配置
	TOKENNAME: 'Authori-zation',
	// 缓存时间 0 永久
	EXPIRE: 0,
	//分页最多显示条数
	LIMIT: 10
}



// WEBPACK FOOTER //
// ./src/config/app.js